<div class="shadow-grey rounded-sm bg-white pb-2">
  <div class="flex items-center justify-between gap-2 px-4 pt-4">
    <span class="paragraph-large-semibold">Centre d'aide</span>
    <button (click)="closeAide()" hlmBtn variant="ghost" size="icon" aria-label="Fermer le centre d'aide">
      <ng-icon name="lucideX" />
    </button>
  </div>
  <div class="border-grey-2 my-4 border-t"></div>
  <div>
    <ng-container
      [ngTemplateOutlet]="helpContainer"
      [ngTemplateOutletContext]="{
        title: 'Tutoriel',
        icon: 'lucideBookOpen',
        subtitle: 'Savoir utiliser l\'outil le Compas.',
        items: tutoriels,
      }"
    />
    <div class="border-grey-2 my-4 border-t"></div>
    <ng-container
      [ngTemplateOutlet]="helpContainer"
      [ngTemplateOutletContext]="{
        title: 'Méthode',
        icon: 'lucidePencilRuler',
        subtitle: 'Aide pour suivre le processus carto.',
        items: methodes,
      }"
    />
  </div>
</div>

<ng-template #helpContainer let-title="title" let-subtitle="subtitle" let-items="items" let-icon="icon">
  <div class="flex flex-col">
    <div class="flex gap-3 px-4 pb-2">
      <div class="bg-container-img-light-orange text-secondary h-10 w-10 rounded-sm p-2">
        <ng-icon [name]="icon" />
      </div>
      <div class="flex flex-col">
        <span class="paragraph-large-semibold">{{ title }}</span>
        <span class="text-grey-8 paragraph-small-medium">{{ subtitle }}</span>
      </div>
    </div>

    @for (item of items; track item.id) {
      <a class="justify-between" [href]="item.urlWiki" hlmBtn variant="ghost">
        <span class="action-medium-semibold">{{ item.libelle }}</span>
        <ng-icon name="lucideSquareArrowOutUpRight" />
      </a>
    }
  </div>
</ng-template>
